var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-calendar',{ref:"calendar",scopedSlots:_vm._u([{key:"day-body",fn:function(ref){
var date = ref.date;
var week = ref.week;
return _vm._l((_vm.timeSlots),function(time){return _c('div',{key:time,staticClass:"v-current-time",class:{ first: date === week[0].date },style:({ top: _vm.calculateTop(time) })},[_vm._v(" "+_vm._s(time)+" ")])})}}])})}
var staticRenderFns = []

export { render, staticRenderFns }